import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavbarComponent } from './navbar/navbar.component';
import { RouterModule } from '@angular/router';
import { DragDropDirective } from './drag-drop.directive';
import { ContactFormComponent } from './contact-form/contact-form.component';
import { MatStepperModule, MatFormFieldModule, MatInputModule, MatCheckboxModule, MatDatepickerModule, MatNativeDateModule, MatAutocompleteModule, MatSelectModule, MatMenuModule, MatSnackBarModule } from '@angular/material';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { FooterComponent } from './footer/footer.component';
import { NgZorroAntdModule } from 'node_modules/ng-zorro-antd';


@NgModule({
  declarations: [
    NavbarComponent,
    DragDropDirective,
    ContactFormComponent,
    FooterComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    MatStepperModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    FormsModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatAutocompleteModule,
    MatSelectModule,
    MatMenuModule,
    MatSnackBarModule,
    NgZorroAntdModule,
  ],
  exports: [
    NavbarComponent,
    DragDropDirective,
    ContactFormComponent,
    FooterComponent
  ]
})
export class SharedModule { }

